import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Table, Space, Input, Modal, Form } from "antd";
import { firestore} from "../config/firebase";

import {
  collection,
  getDocs,
  updateDoc,
  getDoc,
  doc,
  deleteDoc,
} from "firebase/firestore";
import { DeleteOutlined } from "@ant-design/icons";
import UserForm from "./userForm";

const UserList = () => {
  const navigate = useNavigate();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [totalRecords, setTotalRecords] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [initialData, setInitialData] = useState([]);
  const [displayedData, setDisplayedData] = useState(initialData.slice(0, 10));
  const [isDeleteModalVisible, setDeleteModalVisible] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [addUserForm] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedItem, setSelectedItem] = useState("");
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;
  const [order, setOrder] = useState({ name: "asc", total: "asc" });
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    dateJoined: "",
    email: "",
    phone: "",
    profilePicture: "",
    city: "",
    state: "",
    totalEarning: "",
    activeTime: "",
    available: "",
    callCount: "",
    chatSessions: "",
    country: "",
    earningsMonth: "",
    isActive: "",
    isWaiting: "",
    rating: "",
    totalCallTime: "",
  });

  const handleStatusChange = (e, key) => {
    const updatedDisplayedData = displayedData.map((item) =>
      item.key === key ? { ...item, status: e.target.value } : item
    );
    setDisplayedData(updatedDisplayedData);
  };
  const showDeleteModal = (id) => {
    setUserToDelete(id);
    setDeleteModalVisible(true);
  };

  const hideDeleteModal = () => {
    setUserToDelete(null);
    setDeleteModalVisible(false);
  };

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const hasSelected = selectedRowKeys.length > 0;

  const handleDeleteUser = (id, e) => {
    e.stopPropagation();
    showDeleteModal(id);
  };

  const handleDeleteConfirmed = async () => {
    try {
      const userRef = doc(firestore, "users", userToDelete);
      const userSnapshot = await getDoc(userRef);

      if (userSnapshot.exists()) {
        await deleteDoc(userRef); // This deletes the document
        fetchDataFromFirestore();
        setUserToDelete("");
      }
      hideDeleteModal();
    } catch (error) {
      console.error("Error updating isDeleted:", error);
    }
  };

  const handleDeleteCancelled = () => {
    hideDeleteModal();
  };

  const handleBlockUser = async (id, isBlocked, e) => {
    e.stopPropagation();
    try {
      await updateDoc(doc(firestore, "users", id), {
        isBlocked: !isBlocked,
      });
      fetchDataFromFirestore();
    } catch (error) {
      console.error("Error updating isBlocked:", error);
    }
  };

  useEffect(() => {
    const sortData = (column, order) => {
      const sortedData = [...initialData].sort((a, b) => {
        if (order === "asc") {
          return a[column] > b[column] ? 1 : -1;
        } else {
          return a[column] < b[column] ? 1 : -1;
        }
      });
      return sortedData;
    };

    const sortedData = sortData(selectedItem, order[selectedItem]);

    setDisplayedData(sortedData);
  }, [initialData, order, selectedItem]);

  const handleClick = (column) => {
    setOrder((prev) => {
      const newOrder = prev[column] === "asc" ? "desc" : "asc";
      return { ...prev, [column]: newOrder };
    });
    setSelectedItem(column);
  };

  function getArrow(order) {
    if (order === "asc") return "↑";
    return "↓";
  }

  const columns = [
    {
      title: "User ID",
      dataIndex: "id",
      align: "center",
    },
    {
      title: (
        <div onClick={() => handleClick("firstName")}>
          First Name {getArrow(order.firstName)}
        </div>
      ),
      dataIndex: "firstName",
      align: "center",
    },
    {
      title: (
        <div onClick={() => handleClick("lastName")}>
          Last Name {getArrow(order.lastName)}
        </div>
      ),
      dataIndex: "lastName",
      align: "center",
    },
    {
      title: (
        <div onClick={() => handleClick("phone")}>
          Phone Number {getArrow(order.phone)}
        </div>
      ),
      dataIndex: "phone",
      align: "center",
    },
    {
      title: (
        <div onClick={() => handleClick("email")}>
          Email {getArrow(order.email)}
        </div>
      ),
      dataIndex: "email",
      align: "center",
    },
    {
      title: (
        <div onClick={() => handleClick("city")}>
          City {getArrow(order.city)}
        </div>
      ),
      dataIndex: "city",
      align: "center",
    },

    {
      title: (
        <div onClick={() => handleClick("country")}>
          Country {getArrow(order.country)}
        </div>
      ),
      dataIndex: "country",
      align: "center",
    },
    {
      title: "Purpose",
      dataIndex: "purpose",
      align: "center",
    },
    // {
    //   title: "Total Minutes Spent On Calls",
    //   dataIndex: "total",
    //   align: "center",
    // },
    {
      title: "Status",
      dataIndex: "isActive",
      align: "center",
      render: (text, record) => (
        <Space>
          <img src="/radiobtn.svg" />
          <span
            style={{ color: record.isActive ? "green" : "", fontSize: "12px" }}
          >
            {record.isActive ? "Active" : "Disabled"}
          </span>
        </Space>
      ),
    },
    {
      dataIndex: "delete",
      align: "center",
      render: (text, record) => (
        <Space>
          <DeleteOutlined
            style={{ fontSize: "18px", cursor: "pointer" }}
            onClick={(e) => handleDeleteUser(record.id, e)}
          />
        </Space>
      ),
    },

    {
      dataIndex: "block",
      align: "center",
      render: (text, record) => (
        <Space>
          <Button
            type={record.isBlocked ? "default" : "primary"}
            danger={!record.isBlocked}
            onClick={(e) => handleBlockUser(record.id, record.isBlocked, e)}
          >
            {record.isBlocked ? "Unblock" : "Block"}
          </Button>
        </Space>
      ),
    },
  ];

  const loadAllData = () => {
    setDisplayedData(initialData);
    setTotalRecords(initialData.length);
  };

  useEffect(() => {
    fetchDataFromFirestore();
  }, []);

  const fetchDataFromFirestore = async () => {
    try {
      const querySnapshot = await getDocs(collection(firestore, "users"));
      const firebaseData = querySnapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((counsellor) => !counsellor.isDeleted);

      setInitialData(firebaseData);
      setDisplayedData(firebaseData.slice(0, 10));
      setTotalRecords(firebaseData.length);
    } catch (error) {
      console.error("Error fetching data from Firebase:", error);
    }
  };

  const handleSearch = (value) => {
    setSearchText(value);

    const filteredData = initialData.filter(
      (item) =>
        `${item.firstName} ${item.lastName}`
          .toLowerCase()
          .includes(value.toLowerCase()) ||
        item.firstName.toLowerCase().includes(value.toLowerCase()) ||
        item.lastName.toLowerCase().includes(value.toLowerCase()) ||
        item.id.toLowerCase().includes(value.toLowerCase()) ||
        item.email.toLowerCase().includes(value.toLowerCase()) ||
        item.phone.includes(value) ||
        item.city.toLowerCase().includes(value.toLowerCase()) ||
        item.country.toLowerCase().includes(value.toLowerCase())
    );
    setDisplayedData(filteredData);
    setTotalRecords(filteredData.length);
  };

  const handleDeleteAll = async () => {
    try {
      const selectedCounsellorIds = selectedRowKeys;
      for (const id of selectedCounsellorIds) {
        await updateDoc(doc(firestore, "users", id), {
          isDeleted: true,
        });
      }
      fetchDataFromFirestore();
      setSelectedRowKeys([]);
    } catch (error) {
      console.error("Error updating isDeleted:", error);
    }
  };

  const shouldRenderViewAllButton = displayedData.length > 10;

  const rowClassName = (record, index) => {
    return "pointer-cursor";
  };

  return (
    <div
      style={{
        alignItems: "center",
        overflow: "auto",
        maxHeight: "100vh",
        paddingRight: "0px",
        width: "97.5%",
      }}
    >
      <Modal
        title="Confirm Deletion"
        open={isDeleteModalVisible}
        onOk={handleDeleteConfirmed}
        onCancel={handleDeleteCancelled}
        okText="Yes"
        cancelText="No"
      >
        Are you sure you want to delete this user?
      </Modal>
      <div style={{ marginTop: "-60px", alignItems: "center" }}>
        <Input
          className="placeholder_search"
          prefix={
            <img
              src="/search.svg"
              style={{ width: "24px", height: "24px", marginRight: "8px" }}
            />
          }
          placeholder="Search"
          style={{
            flex: 1,
            width: "352px",
            height: "37px",
            borderRadius: "19px",
            background: " rgb(235,235,235)",
            marginBottom: "40px",
            border: "none",
            color: "black",
            paddingTop: "5px",
          }}
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
        />
      </div>
      <div style={{ marginBottom: 16 }}>
        <Button
          onClick={() => setIsModalVisible(true)}
          style={{
            width: "173px",
            height: "43px",
            borderRadius: "22.5px",
            textAlign: "left",
            background: " rgba(24, 64, 125, 1)",
            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
            color: "white",
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: "500",
            lineHeight: "21px",
            textAlign: "center",
            letterSpacing: "-0.022em",
            border: "none",
            fontWeight: "medium",
          }}
        >
          + Add new User
        </Button>

        {shouldRenderViewAllButton && (
          <Button
            onClick={loadAllData}
            style={{
              color: "rgba(0, 0, 0, 1)",
              border: "none",
              marginLeft: "93.5%",
              Weight: "500",
              fontSize: "12px",
              fontFamily: "Inter, sans-serif",
              fontWeight: "bold",
            }}
          >
            View All
          </Button>
        )}
        {hasSelected && (
          <Button
            onClick={handleDeleteAll}
            style={{
              color: "rgba(0, 0, 0, 1)",
              border: "none",
              Weight: "500",
              fontSize: "12px",
              fontFamily: "Inter, sans-serif",
              fontWeight: "bold",
            }}
          >
            Delete All
          </Button>
        )}

        <UserForm
          toggleModal={() => setIsModalVisible(false)}
          refreshList={fetchDataFromFirestore}
          isModalVisible={isModalVisible}
        />
      </div>

      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={displayedData}
        pagination={false}
        rowKey="id"
        rowClassName={rowClassName}
        onRow={(record) => ({
          onClick: () => {
            if (!record.isBlocked) {
              setSelectedUser(record);
              navigate("/user", { state: { selectedUser: record } });
            }
          },
        })}
      />
      <div
        style={{
          marginTop: "30px",
          color: "rgba(0, 0, 0, 1)",
          Weight: "500",
          fontSize: "10px",
          fontFamily: "Inter, sans-serif",
          fontWeight: "medium",
        }}
      >
        {" "}
        Showing {displayedData.length} from {totalRecords} data
      </div>
    </div>
  );
};

export default UserList;
